<mat-sidenav-container class="example-container">
  <mat-sidenav #sidenav mode="side"
    
    class="sidenav-padding">
    <br>

      Document Review Actions

      <br>

        <button mat-button
          color="primary"
          (click)="newDocumentVersion()">
          Bookmark As New Version
        </button>

        <br>
          <mat-divider></mat-divider>

          <button mat-button
            color="primary"
            (click)="editDocumentReview()">
            Edit This Document Review
          </button>

          <mat-divider></mat-divider>

          <button mat-button
            (click)="goToCurrentContract()"
            color="primary">
            View Active Contract
          </button>

          <mat-divider></mat-divider>

          <button mat-button
            [disabled]="true"
            color="primary">
            Update Document Review Version
          </button>

          <br>

            <button mat-button
              [disabled]="true"
              color="primary">
              Add Attachments
            </button>

            <br>

              <button mat-button
                [disabled]="false"
                (click)="addNewInternalTaskRequest()"
                color="primary">
                Assign Task To Internal User
              </button>

              <br>

                <button mat-button
                  [disabled]="true"
                  color="primary">
                  Assign Task To External Person
                </button>

                <br>
                  <br>
                    <mat-divider></mat-divider>
                    <br>

                      <button mat-button
                        [disabled]="!existingActiveContract"
                        color="primary"
                        (click)="replaceContract()">
                        Replace Current Contract
                      </button>

                      <br>

                        <button mat-button
                          [disabled]="!existingActiveContract"
                          color="primary"
                          (click)="createNewContract()">
                          Create New Contract
                        </button>


                        <br>

                          <button mat-button
                            [disabled]= true
                            color="primary"
                            (click)="addEntityAsAttachment()">
                            Add To Contract As Attachment
                          </button>

                        </mat-sidenav>

                        <mat-sidenav-content>

                          <table style="width:100%">
                            <tr>
                              <th><h3>Document Review Status:  &nbsp; &nbsp; {{ currentDocReview.Status }}</h3></th>
                              <th><h3>Version:  {{ currentVersion }} of {{ totalNumberOfVersions }}</h3></th>
                            </tr>
                          </table>

                          <!-- <h3>Document Review Status: &nbsp; &nbsp; {{ currentDocReview.status }}</h3>
                          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                          <h3>Version: {{ currentVersion }} of {{ totalNumberOfVersions }}</h3> -->

                          @if (docReviewLoadingError) {
                            <div>
                              <h1>Many apologies.  BDA encountered an error trying to load your Document Review.</h1>
                              <br>
                                <br>
                                  <h3>
                                    <a [routerLink]="['/securehome/contracts']">Contracts List</a>
                                  </h3>
                                </div>
                              }

                              <!-- SECTION IF FORM ID IS THERE -->
                              @if (!docReviewLoadingError) {
                                <div>
                                  <mat-tab-group
                                    (selectedTabChange)="tabChanged($event)">
                                    <mat-tab label="Details">
                                      <mat-grid-list cols="12" rowHeight="50px">
                                        <mat-grid-tile
                                          [colspan]=6
                                          [rowspan]=1>
                                        </mat-grid-tile>
                                        <mat-grid-tile
                                          [colspan]=6
                                          [rowspan]=1>
                                          <mat-radio-group
                                            [disabled]="missingContractFile"
                                            class="contract-view-radio-group"
                                            [(ngModel)]="selectedViewMode"
                                            name="selectedViewMode">
                                            @for (viewMode of contractViewModesWithoutText; track viewMode) {
                                              <mat-radio-button
                                                class="contract-view-radio-button"
                                                [value]="viewMode"
                                                [checked]="contractViewMode">
                                                {{viewMode}}
                                              </mat-radio-button>
                                            }
                                          </mat-radio-group>
                                        </mat-grid-tile>
                                        <mat-grid-tile
                                          [colspan]=6
                                          [rowspan]=3>
                                          <div class="left-align-header">Name<br>
                                            <font
                                              color="black"
                                              size="5">
                                              {{currentDocReview.name}}
                                            </font>
                                          </div>
                                        </mat-grid-tile>
                                        <mat-grid-tile
                                          [colspan]=6
                                          [rowspan]=20>
                                          @if (selectedViewMode == 'Hide Contract') {
                                            <div>
                                              <h1>View your contract here after uploading.</h1>
                                            </div>
                                          }
                                          @if (selectedViewMode == 'Original' && !isOfficeDocument) {
                                            <div
                                              class="top-right-align"
                                              [innerHTML]="safePdfHtml">
                                            </div>
                                          }
                                          @if (selectedViewMode == 'Original' && isOfficeDocument) {
                                            <div  class="top-right-align"
                                              >
                                              <iframe [src]="trustedOfficeSource" width='750px' height='1000px' frameborder='0'>This is an embedded <a target='_blank' href='http://office.com'>Microsoft Office</a> document, powered by <a target='_blank' href='http://office.com/webapps'>Office Online</a>.</iframe>
                                            </div>
                                          }
                                        </mat-grid-tile>
                                        <mat-grid-tile
                                          [colspan]=6
                                          [rowspan]=3>
                                          <div class="left-align-header">Description<br>
                                            <font
                                              color="black"
                                              size="4">
                                              {{currentDocReview.description}}
                                            </font>
                                          </div>
                                        </mat-grid-tile>
                                        <!-- <mat-grid-tile
                                        [colspan]=6
                                        [rowspan]=1>
                                      </mat-grid-tile>   -->
                                      <mat-grid-tile
                                        [colspan]=3
                                        [rowspan]=3>
                                        <div class="left-align-header">Party<br>
                                          <font
                                            color="black"
                                            size="4">
                                            {{ partyFriendlyName }}
                                          </font>
                                        </div>
                                      </mat-grid-tile>
                                      <mat-grid-tile
                                        [colspan]=3
                                        [rowspan]=1>
                                        <div class="left-align-header">Contract Type<br>
                                          <font
                                            color="black"
                                            size="4">
                                            {{currentDocReview.entityUnderReviewObject.contractType}}
                                          </font>
                                        </div>
                                      </mat-grid-tile>
                                      <mat-grid-tile
                                        [colspan]=3
                                        [rowspan]=3>
                                        <div class="left-align-header">Legal Entity<br>
                                          <font
                                            color="black"
                                            size="4">
                                            {{ currentDocReview.entityUnderReviewObject.legalEntitiesNameDisplay }}
                                          </font>
                                        </div>
                                      </mat-grid-tile>
                                      <mat-grid-tile
                                        [colspan]=3
                                        [rowspan]=1>
                                        <div class="left-align-header">Site<br>
                                          <font
                                            color="black"
                                            size="4">
                                            {{siteFriendlyNames}}
                                          </font>
                                        </div>
                                      </mat-grid-tile>
                                      <mat-grid-tile
                                        [colspan]=3
                                        [rowspan]=1>
                                        <div class="left-align-header">Requestor<br>
                                          <font
                                            color="black"
                                            size="4">
                                            {{currentDocReview.requestor}}
                                          </font>
                                        </div>
                                      </mat-grid-tile>
                                      <mat-grid-tile
                                        [colspan]=3
                                        [rowspan]=1>
                                        <div class="left-align-header">Requestor Notes<br>
                                          <font
                                            color="black"
                                            size="4">
                                            {{currentDocReview.requestorNotes}}
                                          </font>
                                        </div>
                                      </mat-grid-tile>
                                    </mat-grid-list>
                                  </mat-tab>
                                  <mat-tab label="Reviews">
                                    <mat-grid-list cols="12" rowHeight="50px">
                                      <mat-grid-tile
                                        [colspan]=12
                                        [rowspan]=1>
                                        <div class="left-align-header">Name<br>
                                          <font
                                            color="black"
                                            size="5">
                                            {{currentDocReview.name}}
                                          </font>
                                        </div>
                                      </mat-grid-tile>
                                      <mat-grid-tile
                                        [colspan]=6
                                        [rowspan]=10>
                                        <ag-grid-angular
                                          style="width: 95%; height: 400px;"
                                          class="ag-theme-balham"
                                          
                                          [rowData]="requestedReviewsList"
                                          [columnDefs]="columnDefs"
                                          (gridReady)="onGridReady($event)"
                                          (cellClicked)="viewImportantDateDetails($event)"
                                          >
                                        </ag-grid-angular>
                                      </mat-grid-tile>
                                      <mat-grid-tile
                                        [colspan]=6
                                        [rowspan]=1>
                                        <mat-radio-group
                                          [disabled]="missingContractFile"
                                          class="contract-view-radio-group"
                                          [(ngModel)]="selectedViewMode"
                                          name="selectedViewMode">
                                          @for (viewMode of contractViewModesWithoutText; track viewMode) {
                                            <mat-radio-button
                                              class="contract-view-radio-button"
                                              [value]="viewMode"
                                              [checked]="contractViewMode">
                                              {{viewMode}}
                                            </mat-radio-button>
                                          }
                                        </mat-radio-group>
                                      </mat-grid-tile>
                                      <mat-grid-tile
                                        [colspan]=6
                                        [rowspan]=1>
                                      </mat-grid-tile>
                                      <mat-grid-tile
                                        [colspan]=6
                                        [rowspan]=20>
                                        @if (selectedViewMode == 'Hide Contract') {
                                          <div>
                                            <h1>View your contract here after uploading.</h1>
                                          </div>
                                        }
                                        @if (selectedViewMode == 'Original' && !isOfficeDocument) {
                                          <div
                                            class="top-right-align"
                                            [innerHTML]="safePdfHtml">
                                          </div>
                                        }
                                        @if (selectedViewMode == 'Original' && isOfficeDocument) {
                                          <div  class="top-right-align"
                                            >
                                            <iframe [src]="trustedOfficeSource" width='750px' height='1000px' frameborder='0'>This is an embedded <a target='_blank' href='http://office.com'>Microsoft Office</a> document, powered by <a target='_blank' href='http://office.com/webapps'>Office Online</a>.</iframe>
                                          </div>
                                        }
                                      </mat-grid-tile>
                                    </mat-grid-list>
                                  </mat-tab>
                                  <mat-tab label="Document Versions">
                                    <mat-grid-list cols="12" rowHeight="50px">
                                      <mat-grid-tile
                                        [colspan]=12
                                        [rowspan]=1>
                                        <div class="left-align-header">Name<br>
                                          <font
                                            color="black"
                                            size="5">
                                            {{currentDocReview.name}}
                                          </font>
                                        </div>
                                      </mat-grid-tile>
                                      <mat-grid-tile
                                        [colspan]=6
                                        [rowspan]=10>
                                        <ag-grid-angular
                                          style="width: 95%; height: 400px;"
                                          class="ag-theme-balham"
                                          
                                          [rowData]="documentVersions"
                                          [columnDefs]="docVersionsColumnDefs"
                                          (gridReady)="onVersionListGridReady($event)"
                                          (cellClicked)="switchFormToThisVersion($event)"
                                          >
                                        </ag-grid-angular>
                                      </mat-grid-tile>
                                      <mat-grid-tile
                                        [colspan]=6
                                        [rowspan]=1>
                                        <mat-radio-group
                                          [disabled]="missingContractFile"
                                          class="contract-view-radio-group"
                                          [(ngModel)]="selectedViewMode"
                                          name="selectedViewMode">
                                          @for (viewMode of contractViewModesWithoutText; track viewMode) {
                                            <mat-radio-button
                                              class="contract-view-radio-button"
                                              [value]="viewMode"
                                              [checked]="contractViewMode">
                                              {{viewMode}}
                                            </mat-radio-button>
                                          }
                                        </mat-radio-group>
                                      </mat-grid-tile>
                                      <mat-grid-tile
                                        [colspan]=6
                                        [rowspan]=1>
                                      </mat-grid-tile>
                                      <mat-grid-tile
                                        [colspan]=6
                                        [rowspan]=20>
                                        @if (selectedViewMode == 'Hide Contract') {
                                          <div>
                                            <h1>View your contract here after uploading.</h1>
                                          </div>
                                        }
                                        @if (selectedViewMode == 'Original' && !isOfficeDocument) {
                                          <div
                                            class="top-right-align"
                                            [innerHTML]="safePdfHtml">
                                          </div>
                                        }
                                        @if (selectedViewMode == 'Original' && isOfficeDocument) {
                                          <div  class="top-right-align"
                                            >
                                            <iframe [src]="trustedOfficeSource" width='750px' height='1000px' frameborder='0'>This is an embedded <a target='_blank' href='http://office.com'>Microsoft Office</a> document, powered by <a target='_blank' href='http://office.com/webapps'>Office Online</a>.</iframe>
                                          </div>
                                        }
                                      </mat-grid-tile>
                                    </mat-grid-list>
                                  </mat-tab>
                                </mat-tab-group>
                              </div>
                            }





                          </mat-sidenav-content>
                        </mat-sidenav-container>

